/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var k=(new Date).getTime(),b=setInterval(function(){if(3845<(new Date).getTime()-k)clearInterval(b);else{var e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,98,101,116,97,46,97,108,105,104,117,110,116,101,114,46,105,111,39,93));for(e.length<1&&(e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,97,108,105,104,117,110,116,101,114,46,105,111,39,93)));0<e.length;)e[0].style.display=String.fromCodePoint(110,111,110,101)}},769);document.addEventListener(String.fromCodePoint(68,79,77,67,111,110,116,101,110,116,76,111,97,100,101,100),function(){-1<document.location.href.indexOf(String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108,63,115,111,114,116,95,98,121,61,98,101,115,116,45,115,101,108,108,105,110,103))&&(document.location.href=String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108))},!1);

if (window.matchMedia("(max-width: 768px)").matches) {
  	window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
	}
} 

function parcelamento() {
  var preco = $('.product-form__info-item .price--highlight').text().split('                  ')[0].replace('R$ ','').replace(',', '.').trim()
  var compare = $('.product-form__info-item .price--compare').text().replace('R$ ', '').replace(',','.')
  var compare = parseFloat(compare)
  var precompare = (compare - preco).toFixed(2).replace('.', ',')
  $('.product-label.product-label--on-sale span').text('R$ '+ precompare)
  var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0]
  $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%')    
  var preco = parseFloat(preco);
  var calculo = ((preco + 0) * 1.1979) / 12;
  var calculo = calculo.toFixed(2).replace('.', ',');
  var calculo = ('R$ ' + calculo);
  $('.parcelamento').html('<span>em até 12x de <b>' + calculo + '</b></span>');
}


$(".block-swatch__radio").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});

/**
 * Popup de vídeo flutuante na página do produto (Ramon - 08/09/2026).
 * A bolha só aparece quando o produto tem o campo "Vídeo popup" (metafield
 * custom.video_popup) preenchido no admin. Ao clicar, abre um popup central
 * com o vídeo (YouTube, Vimeo ou link direto de arquivo .mp4). O vídeo só é
 * carregado quando o cliente clica, para não pesar a página por padrão.
 */
(function () {
  function getEmbedHtml(src) {
    var ytMatch = src.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|embed\/))([\w-]{11})/);
    if (ytMatch) {
      return '<iframe src="https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&playsinline=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    }

    var vimeoMatch = src.match(/vimeo\.com\/(?:.*\/)?(\d+)/);
    if (vimeoMatch) {
      return '<iframe src="https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    }

    return '<video src="' + src + '" controls autoplay playsinline></video>';
  }

  function init() {
    var bubble = document.getElementById('vip-video-bubble');
    var modal = document.getElementById('vip-video-modal');
    if (!bubble || !modal || bubble.dataset.vipBound) return;
    bubble.dataset.vipBound = 'true';

    var content = document.getElementById('vip-video-modal-content');

    function openModal() {
      content.innerHTML = getEmbedHtml(bubble.dataset.videoSrc);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      content.innerHTML = ''; // para o vídeo ao fechar
      document.body.style.overflow = '';
    }

    bubble.addEventListener('click', openModal);
    bubble.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openModal();
      }
    });

    Array.prototype.forEach.call(modal.querySelectorAll('[data-action="vip-close-video"]'), function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();

/**
 * Preview na bolha do vídeo (Ramon - 01/10/2026).
 * A bolha passa a mostrar o próprio vídeo rodando em miniatura (sem som, em
 * loop), estilo "Stories", para chamar a atenção do cliente:
 * - Link direto de vídeo (ex.: Arquivos da Shopify, .mp4): mostra o vídeo
 *   rodando dentro da bolha.
 * - YouTube: mostra a capa (thumbnail) do vídeo.
 * - Vimeo ou formato desconhecido: mantém a bolha escura com o ícone de play.
 * O preview pausa enquanto o popup está aberto e volta ao fechar.
 */
(function () {
  var STYLE_ID = 'vip-video-preview-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = '' +
      '.vip-video-bubble.has-preview{width:76px;height:76px;padding:3px;overflow:visible;' +
        'background:linear-gradient(45deg,#c9a24d,#f3e2b3,#c9a24d);}' +
      '.vip-video-bubble.has-preview .vip-video-bubble__media{position:absolute;inset:3px;' +
        'border-radius:50%;overflow:hidden;background:#1c1b1b;border:2px solid #fff;}' +
      '.vip-video-bubble.has-preview .vip-video-bubble__media video,' +
      '.vip-video-bubble.has-preview .vip-video-bubble__media img{width:100%;height:100%;' +
        'object-fit:cover;display:block;pointer-events:none;}' +
      '.vip-video-bubble.has-preview > svg{position:absolute;right:-2px;bottom:-2px;z-index:2;' +
        'width:24px;height:24px;margin:0;padding:6px 5px 6px 7px;box-sizing:border-box;' +
        'border-radius:50%;background:#1c1b1b;border:2px solid #fff;fill:#fff;}' +
      '@media screen and (max-width:640px){' +
        '.vip-video-bubble.has-preview{width:66px;height:66px;}' +
        '.vip-video-bubble.has-preview > svg{width:22px;height:22px;}' +
      '}';
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function buildPreview(src) {
    var yt = src.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|embed\/))([\w-]{11})/);
    if (yt) {
      var img = document.createElement('img');
      img.src = 'https://i.ytimg.com/vi/' + yt[1] + '/hqdefault.jpg';
      img.alt = '';
      img.loading = 'lazy';
      return img;
    }

    if (/vimeo\.com\//.test(src)) return null;

    var video = document.createElement('video');
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', 'metadata');
    video.setAttribute('aria-hidden', 'true');
    video.src = src;
    return video;
  }

  function init() {
    var bubble = document.getElementById('vip-video-bubble');
    var modal = document.getElementById('vip-video-modal');
    if (!bubble || bubble.dataset.vipPreview) return;
    bubble.dataset.vipPreview = 'true';

    var media = buildPreview(bubble.dataset.videoSrc || '');
    if (!media) return;

    injectStyle();

    var wrap = document.createElement('span');
    wrap.className = 'vip-video-bubble__media';
    wrap.appendChild(media);
    bubble.insertBefore(wrap, bubble.firstChild);
    bubble.classList.add('has-preview');

    // Se o vídeo/imagem não carregar, volta para a bolha original com o play.
    media.addEventListener('error', function () {
      bubble.classList.remove('has-preview');
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    });

    if (media.tagName !== 'VIDEO') return;

    function tryPlay() {
      var p = media.play();
      if (p && p.catch) p.catch(function () {});
    }
    tryPlay();

    // Pausa o preview enquanto o popup está aberto, volta ao fechar.
    if (modal && window.MutationObserver) {
      new MutationObserver(function () {
        if (modal.classList.contains('is-open')) media.pause();
        else tryPlay();
      }).observe(modal, { attributes: true, attributeFilter: ['class'] });
    }

    // Economiza bateria: pausa quando a aba fica em segundo plano.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) media.pause();
      else if (!modal || !modal.classList.contains('is-open')) tryPlay();
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();

/**
 * Provador de tamanho (Ramon - 01/10/2026).
 * Aparece ao lado do botão "Ver Medidas" nas peças de cima (polo, camisa social
 * e camisetas). O cliente informa altura, peso, tipo de corpo e caimento, ou a
 * largura de uma peça que já veste bem, e recebe o tamanho recomendado com base
 * nas tabelas de medidas da loja (medidas da peça na horizontal, em cm).
 * Um toque em "Selecionar" já marca o tamanho na página.
 */
(function () {
  // Medidas da peça (cm, peça esticada na horizontal): [tórax, barra, comprimento]
  var TABLES = {
    polo: {
      label: 'Polo',
      sizes: [
        ['P', 52, 55, 70], ['M', 53, 55, 73.2], ['G', 56, 57, 74.3], ['GG', 60, 62.5, 76.5],
        ['XXL', 63.3, 64.5, 80.5], ['3XL', 66, 68.5, 81.5], ['4XL', 69.5, 72.5, 87], ['5XL', 72.2, 74.5, 88.7]
      ]
    },
    social: {
      label: 'Camisa social',
      sizes: [
        ['P', 53, 54, 74], ['M', 54, 56, 74], ['G', 57, 58, 77], ['GG', 58, 60, 83],
        ['XXL', 62, 63, 86], ['3XL', 66, 67, 82], ['4XL', 72, 72, 84], ['5XL', 75, 75, 85]
      ]
    },
    pima: {
      label: 'Camiseta Pima',
      sizes: [
        ['P', 46, 48, 67], ['M', 51, 52, 70], ['G', 53, 54, 72], ['GG', 54, 56, 73],
        ['XXL', 57, 58, 78], ['G1', 57, 58, 78], ['G2', 62, 62, 82], ['G3', 67, 67, 84]
      ]
    },
    premium: {
      label: 'T-shirt Premium',
      sizes: [
        ['P', 46, 48, 67], ['M', 51, 52, 70], ['G', 53, 54, 72], ['GG', 54, 56, 73], ['XXL', 56, 58, 77]
      ]
    },
    fitness: {
      label: 'Camiseta Fitness',
      sizes: [
        ['P', 49, 51, 70], ['M', 51, 52, 71], ['G', 56, 57, 77], ['GG', 59, 61, 78], ['XXL', 60, 62, 79]
      ]
    }
  };
  // Modelagem menor (2 cm a menos em cada medida): Camiseta ALO I, Soft ON e Soft ON II.
  TABLES.fitness_slim = {
    label: 'Camiseta Fitness',
    sizes: TABLES.fitness.sizes.map(function (r) { return [r[0], r[1] - 2, r[2] - 2, r[3] - 2]; })
  };
  var SLIM_TITLES = /^camiseta (alo i|soft on|soft on ii)$/;
  // Tabelas que podem aparecer mesmo sem imagem no metacampo (valem para a categoria toda).
  var NO_CHART_OK = { fitness: true, fitness_slim: true };

  // Folga total (cm de circunferência) por caimento. Camisetas têm modelagem
  // mais ajustada ao corpo, então pedem menos folga que polo e camisa.
  var EASE = {
    polo: { justo: 5, regular: 11, solto: 17 },
    social: { justo: 5, regular: 11, solto: 17 },
    pima: { justo: 0, regular: 5, solto: 10 },
    premium: { justo: 0, regular: 5, solto: 10 },
    fitness: { justo: -2, regular: 3, solto: 8 },
    fitness_slim: { justo: -2, regular: 3, solto: 8 }
  };
  // Ajustes por tipo de corpo: [tórax, cintura]
  var BODY = { magro: [-3, -4], normal: [0, 0], atletico: [5, -2], barriga: [0, 9] };
  var STORAGE_KEY = 'vipFitPerfil';

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  // Descobre qual tabela usar: primeiro pelo tipo/título do produto (mais
  // confiável), depois pelo nome do arquivo da tabela cadastrada no metacampo.
  function resolveTable(type, title, chartUrl, tags) {
    var t = norm(type), n = norm(title).replace(/\s+/g, ' ').trim(), f = norm(chartUrl);
    var g = norm((tags || []).join(' '));
    var text = t + ' ' + n;
    if (/\bpolo\b/.test(text)) return 'polo';
    if (/\b(short|bermuda|calca|sunga|meia|bone|oculos|cinto|tenis|sapato)\b/.test(n)) return null;
    var teeTitle = /camiseta|t-?shirt|nacional|\bregata\b/.test(n);
    if (/\bsocial\b/.test(n) || /^camisa\b/.test(n) || (t === 'camisa' && !teeTitle)) return 'social';
    var isFitness = /\bfitness\b/.test(g) || /\b(dry|infinit|alo|soft on|fitness)\b/.test(n);
    var isTee = teeTitle || isFitness || /camiseta|t-?shirt|\bregata\b/.test(t) || /\b(camiseta|regata)\b/.test(g);
    if (!isTee) return null;
    if (SLIM_TITLES.test(n)) return 'fitness_slim';
    if (isFitness || /dry|fitness/.test(t)) return 'fitness';
    if (/tabela_comparativa[^/]*_4\./.test(f) || /t-?shirt|premium/.test(text)) return 'premium';
    return 'pima';
  }

  function estimateBody(h, w, body) {
    var adj = BODY[body] || BODY.normal;
    return {
      chest: 96 + 0.65 * (w - 70) - 0.25 * (h - 175) + adj[0],
      waist: 86 + 0.85 * (w - 70) - 0.30 * (h - 175) + adj[1]
    };
  }

  // rows: [[tamanho, tórax, barra, comprimento], ...] já filtrados para os
  // tamanhos que o produto tem. Retorna { size, next, note }.
  function recommendByBody(rows, h, w, body, fit, key) {
    var b = estimateBody(h, w, body);
    var easeSet = EASE[key] || EASE.polo;
    var ease = easeSet[fit] != null ? easeSet[fit] : easeSet.regular;
    var targetChest = (b.chest + ease) / 2;
    var targetWaist = (b.waist + 4) / 2;
    var idx = -1;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i][1] >= targetChest - 1 && rows[i][2] >= targetWaist - 1) { idx = i; break; }
    }
    var tooBig = idx === -1;
    if (tooBig) idx = rows.length - 1;
    var row = rows[idx];
    var res = { size: row[0], row: row, next: null, note: '' };
    if (tooBig) {
      res.note = 'Pelas medidas informadas, até o maior tamanho disponível pode ficar justo.';
      return res;
    }
    // Ficou no limite? Sugere o próximo como alternativa mais folgada.
    if (idx < rows.length - 1 && row[1] - targetChest < 1) {
      res.next = rows[idx + 1][0];
    }
    var idealLen = h * (key === 'social' ? 0.43 : 0.41);
    if (row[3] < idealLen - 4) {
      res.note = 'O comprimento pode ficar um pouco curto para a sua altura.';
    } else if (row[3] > idealLen + 6) {
      res.note = 'O comprimento pode ficar um pouco longo para a sua altura.';
    }
    return res;
  }

  // Pela largura (axila a axila) de uma peça que já veste bem.
  function recommendByGarment(rows, width) {
    var best = 0, bestDiff = Infinity;
    for (var i = 0; i < rows.length; i++) {
      var diff = Math.abs(rows[i][1] - width);
      if (diff < bestDiff - 0.01) { bestDiff = diff; best = i; }
    }
    var row = rows[best];
    var res = { size: row[0], row: row, next: null, note: '' };
    if (row[1] < width - 1 && best < rows.length - 1) res.next = rows[best + 1][0];
    if (bestDiff > 4) res.note = 'Nenhum tamanho tem largura próxima da sua peça; confira a tabela de medidas.';
    return res;
  }

  window.VIPFit = {
    TABLES: TABLES,
    resolveTable: resolveTable,
    estimateBody: estimateBody,
    recommendByBody: recommendByBody,
    recommendByGarment: recommendByGarment
  };

  if (typeof document === 'undefined') return;

  var CSS = '' +
    '.sc-wrap[data-vip-fit-row]{display:flex;align-items:center;flex-wrap:wrap;column-gap:8px;}' +
    '.vip-fit-btn{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;width:auto!important;' +
      'min-width:0;height:auto;margin:12px 0;padding:8px 12px;box-sizing:border-box;background:#1c1b1b;color:#fff;' +
      'border:1px solid #1c1b1b;border-radius:2px;font-size:11px;line-height:1.2;white-space:nowrap;' +
      'letter-spacing:.06em;text-transform:uppercase;cursor:pointer;}' +
    '.vip-fit-btn .vip-fit-short{display:none;}' +
    '@media screen and (max-width:480px){.vip-fit-btn{padding:8px 10px;font-size:10.5px;letter-spacing:.04em;}' +
      '.vip-fit-btn .vip-fit-long{display:none;}.vip-fit-btn .vip-fit-short{display:inline;}}' +
    '.vip-fit-btn:hover{background:#000;}' +
    '.vip-fit-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:99999;' +
      'align-items:center;justify-content:center;padding:16px;}' +
    '.vip-fit-overlay.is-open{display:flex;}' +
    '.vip-fit-modal{position:relative;background:#fff;color:#1c1b1b;width:100%;max-width:420px;max-height:90vh;' +
      'overflow-y:auto;border-radius:8px;padding:24px 20px 20px;box-sizing:border-box;font-size:14px;}' +
    '.vip-fit-modal h3{margin:0 0 4px;font-size:18px;letter-spacing:.02em;}' +
    '.vip-fit-sub{margin:0 0 16px;color:#6b6b6b;font-size:13px;}' +
    '.vip-fit-close{position:absolute;top:8px;right:10px;background:none;border:0;font-size:24px;line-height:1;' +
      'cursor:pointer;color:#333;padding:4px;}' +
    '.vip-fit-tabs{display:flex;gap:6px;margin-bottom:16px;}' +
    '.vip-fit-tab{flex:1;padding:9px 6px;border:1px solid #d6d6d6;background:#fff;border-radius:4px;font-size:12px;' +
      'cursor:pointer;color:#1c1b1b;}' +
    '.vip-fit-tab.is-active{border-color:#1c1b1b;background:#1c1b1b;color:#fff;}' +
    '.vip-fit-row{display:flex;gap:10px;}' +
    '.vip-fit-row .vip-fit-field{flex:1;}' +
    '.vip-fit-field{margin-bottom:14px;}' +
    '.vip-fit-field label{display:block;font-weight:600;font-size:12px;letter-spacing:.04em;' +
      'text-transform:uppercase;margin-bottom:6px;}' +
    '.vip-fit-field input{width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #d6d6d6;' +
      'border-radius:4px;font-size:16px;}' +
    '.vip-fit-hint{font-size:12px;color:#6b6b6b;margin-top:4px;}' +
    '.vip-fit-chips{display:flex;flex-wrap:wrap;gap:6px;}' +
    '.vip-fit-chip{padding:8px 12px;border:1px solid #d6d6d6;border-radius:20px;background:#fff;font-size:13px;' +
      'cursor:pointer;color:#1c1b1b;}' +
    '.vip-fit-chip.is-active{border-color:#c9a24d;background:#faf4e6;font-weight:600;}' +
    '.vip-fit-go{width:100%;padding:13px;background:#1c1b1b;color:#fff;border:0;border-radius:4px;font-size:14px;' +
      'letter-spacing:.08em;text-transform:uppercase;cursor:pointer;margin-top:4px;}' +
    '.vip-fit-error{color:#b3261e;font-size:13px;margin:0 0 10px;}' +
    '.vip-fit-result{text-align:center;padding:8px 0 4px;}' +
    '.vip-fit-result-label{font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:#6b6b6b;}' +
    '.vip-fit-result-size{font-size:56px;font-weight:700;line-height:1.1;margin:6px 0;}' +
    '.vip-fit-result-size span{display:inline-block;min-width:96px;padding:4px 18px;border:2px solid #c9a24d;' +
      'border-radius:8px;}' +
    '.vip-fit-result p{margin:8px 0;font-size:13px;color:#444;}' +
    '.vip-fit-stock{color:#b3261e!important;}' +
    '.vip-fit-link{background:none;border:0;color:#1c1b1b;text-decoration:underline;font-size:13px;cursor:pointer;' +
      'margin-top:10px;padding:4px;}';

  function injectStyle() {
    if (document.getElementById('vip-fit-style')) return;
    var s = document.createElement('style');
    s.id = 'vip-fit-style';
    s.appendChild(document.createTextNode(CSS));
    document.head.appendChild(s);
  }

  function loadProfile() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch (e) { return {}; }
  }
  function saveProfile(p) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(p)); } catch (e) {}
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function productJsonUrl() {
    var path = location.pathname.replace(/\/$/, '');
    var m = path.match(/(.*\/products\/[^\/]+)/);
    return m ? m[1] + '.js' : null;
  }

  function findSizeOption(product) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = typeof opts[i] === 'string' ? opts[i] : opts[i].name;
      if (/^(tamanho|size|tam\.?)$/i.test(String(name).trim())) {
        return { index: i, position: i + 1, name: name, values: opts[i].values || [] };
      }
    }
    return null;
  }

  // Seleciona o tamanho na página, usando o próprio seletor do tema.
  function selectSize(opt, value) {
    var inputs = document.querySelectorAll('.product-form__single-selector[data-option-position="' + opt.position + '"]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      if (el.tagName === 'SELECT') {
        el.value = value;
        el.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      if (el.value === value) {
        var label = el.id ? document.querySelector('label[for="' + el.id + '"]') : null;
        if (label) label.click(); else el.click();
        return true;
      }
    }
    return false;
  }

  function currentSelection(opt) {
    var sel = [];
    var all = document.querySelectorAll('.product-form__single-selector');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      var pos = parseInt(el.getAttribute('data-option-position'), 10);
      if (!pos) continue;
      if (el.tagName === 'SELECT') sel[pos - 1] = el.value;
      else if (el.checked) sel[pos - 1] = el.value;
    }
    return sel;
  }

  // Está disponível nas outras opções escolhidas (ex.: a cor selecionada)?
  function isAvailable(product, opt, size) {
    var sel = currentSelection(opt);
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = v.options && v.options[opt.index] === size;
      for (var j = 0; ok && j < v.options.length; j++) {
        if (j !== opt.index && sel[j] && v.options[j] !== sel[j]) ok = false;
      }
      if (ok) return !!v.available;
    }
    return false;
  }

  function build(product, opt, key, rows, wrap) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vip-fit-btn';
    btn.setAttribute('aria-label', 'Descubra seu tamanho');
    btn.innerHTML = '<span class="vip-fit-long">Descubra seu tamanho</span><span class="vip-fit-short">Meu tamanho</span>';
    if (wrap) {
      wrap.setAttribute('data-vip-fit-row', '1');
      var scBtn = wrap.querySelector('.sc-btn');
      if (scBtn && scBtn.nextSibling) wrap.insertBefore(btn, scBtn.nextSibling); else wrap.appendChild(btn);
    } else {
      // Produto sem tabela no metacampo: coloca o botão logo abaixo do seletor de tamanho.
      var sizeInput = document.querySelector('.product-form__single-selector[data-option-position="' + opt.position + '"]');
      var block = sizeInput && sizeInput.closest ? sizeInput.closest('.product-form__option') : null;
      if (!block || !block.parentNode) return;
      var holder = document.createElement('div');
      holder.className = 'vip-fit-wrap';
      block.parentNode.insertBefore(holder, block.nextSibling);
      btn.style.marginLeft = '0';
      holder.appendChild(btn);
    }
    injectStyle();

    var overlay = document.createElement('div');
    overlay.className = 'vip-fit-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = '<div class="vip-fit-modal"><button type="button" class="vip-fit-close" aria-label="Fechar">×</button><div class="vip-fit-body"></div></div>';
    document.body.appendChild(overlay);
    var bodyEl = overlay.querySelector('.vip-fit-body');

    var profile = loadProfile();
    var state = {
      mode: profile.mode || 'corpo',
      h: profile.h || '', w: profile.w || '',
      body: profile.body || 'normal', fit: profile.fit || 'regular',
      width: profile.width || ''
    };

    function chips(name, options, value) {
      var html = '<div class="vip-fit-chips" data-name="' + name + '">';
      for (var i = 0; i < options.length; i++) {
        html += '<button type="button" class="vip-fit-chip' + (options[i][0] === value ? ' is-active' : '') +
          '" data-value="' + options[i][0] + '">' + options[i][1] + '</button>';
      }
      return html + '</div>';
    }

    function renderForm(error) {
      var html = '<h3>Descubra seu tamanho</h3>' +
        '<p class="vip-fit-sub">' + esc(TABLES[key].label) + ' • leva 10 segundos</p>' +
        '<div class="vip-fit-tabs">' +
          '<button type="button" class="vip-fit-tab' + (state.mode === 'corpo' ? ' is-active' : '') + '" data-mode="corpo">Altura e peso</button>' +
          '<button type="button" class="vip-fit-tab' + (state.mode === 'peca' ? ' is-active' : '') + '" data-mode="peca">Medir uma peça minha</button>' +
        '</div>';
      if (error) html += '<p class="vip-fit-error">' + esc(error) + '</p>';
      if (state.mode === 'corpo') {
        html += '<div class="vip-fit-row">' +
          '<div class="vip-fit-field"><label for="vip-fit-h">Altura (cm)</label>' +
            '<input id="vip-fit-h" type="number" inputmode="numeric" min="140" max="215" placeholder="Ex.: 178" value="' + esc(state.h) + '"></div>' +
          '<div class="vip-fit-field"><label for="vip-fit-w">Peso (kg)</label>' +
            '<input id="vip-fit-w" type="number" inputmode="numeric" min="40" max="200" placeholder="Ex.: 82" value="' + esc(state.w) + '"></div>' +
          '</div>' +
          '<div class="vip-fit-field"><label>Seu corpo</label>' +
            chips('body', [['magro', 'Magro'], ['normal', 'Normal'], ['atletico', 'Atlético'], ['barriga', 'Com barriga']], state.body) +
          '</div>' +
          '<div class="vip-fit-field"><label>Como gosta que a peça vista?</label>' +
            chips('fit', [['justo', 'Mais justa'], ['regular', 'Na medida'], ['solto', 'Mais solta']], state.fit) +
          '</div>';
      } else {
        html += '<div class="vip-fit-field"><label for="vip-fit-width">Largura da sua peça (cm)</label>' +
            '<input id="vip-fit-width" type="number" inputmode="decimal" min="35" max="90" step="0.5" placeholder="Ex.: 55" value="' + esc(state.width) + '">' +
            '<div class="vip-fit-hint">Pegue uma ' + esc(TABLES[key].label.toLowerCase()) + ' que veste bem em você, estenda numa mesa e meça de uma axila à outra.</div>' +
          '</div>';
      }
      html += '<button type="button" class="vip-fit-go">Ver meu tamanho</button>';
      bodyEl.innerHTML = html;
    }

    function renderResult(res) {
      var available = isAvailable(product, opt, res.size);
      var html = '<div class="vip-fit-result">' +
        '<div class="vip-fit-result-label">Seu tamanho ideal</div>' +
        '<div class="vip-fit-result-size"><span>' + esc(res.size) + '</span></div>';
      if (res.next) html += '<p>Se preferir mais folgada, o ' + esc(res.next) + ' também serve.</p>';
      if (res.note) html += '<p>' + esc(res.note) + '</p>';
      if (!available) html += '<p class="vip-fit-stock">Esse tamanho está esgotado na opção selecionada. Veja outra cor ou fale com a gente no WhatsApp.</p>';
      html += '<button type="button" class="vip-fit-go" data-select="' + esc(res.size) + '">' +
          (available ? 'Selecionar tamanho ' + esc(res.size) : 'Ok, entendi') + '</button>' +
        '<button type="button" class="vip-fit-link" data-action="refazer">Refazer</button>' +
        '</div>';
      bodyEl.innerHTML = html;
    }

    function readForm() {
      if (state.mode === 'corpo') {
        var hi = bodyEl.querySelector('#vip-fit-h'), wi = bodyEl.querySelector('#vip-fit-w');
        state.h = hi ? hi.value : state.h;
        state.w = wi ? wi.value : state.w;
      } else {
        var wd = bodyEl.querySelector('#vip-fit-width');
        state.width = wd ? wd.value : state.width;
      }
    }

    function calculate() {
      readForm();
      var res;
      if (state.mode === 'corpo') {
        var h = parseFloat(String(state.h).replace(',', '.'));
        var w = parseFloat(String(state.w).replace(',', '.'));
        if (h > 0 && h < 3) h = h * 100; // digitou 1,78
        if (!(h >= 140 && h <= 215) || !(w >= 40 && w <= 200)) {
          renderForm('Confira a altura (em cm, ex.: 178) e o peso (em kg, ex.: 82).');
          return;
        }
        state.h = String(Math.round(h)); state.w = String(Math.round(w));
        res = recommendByBody(rows, h, w, state.body, state.fit, key);
      } else {
        var width = parseFloat(String(state.width).replace(',', '.'));
        if (!(width >= 35 && width <= 90)) {
          renderForm('Informe a largura da peça em cm (ex.: 55).');
          return;
        }
        res = recommendByGarment(rows, width);
      }
      saveProfile(state);
      renderResult(res);
    }

    function open() {
      renderForm();
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    btn.addEventListener('click', open);
    overlay.addEventListener('click', function (e) {
      var t = e.target;
      if (t === overlay || t.classList.contains('vip-fit-close')) { close(); return; }
      if (t.classList.contains('vip-fit-tab')) { readForm(); state.mode = t.getAttribute('data-mode'); renderForm(); return; }
      if (t.classList.contains('vip-fit-chip')) {
        readForm();
        state[t.parentNode.getAttribute('data-name')] = t.getAttribute('data-value');
        renderForm();
        return;
      }
      if (t.getAttribute('data-action') === 'refazer') { renderForm(); return; }
      if (t.classList.contains('vip-fit-go')) {
        var size = t.getAttribute('data-select');
        if (size) {
          if (isAvailable(product, opt, size)) selectSize(opt, size);
          close();
        } else {
          calculate();
        }
      }
    });
    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT') { e.preventDefault(); calculate(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  }

  function init() {
    var root = document.documentElement;
    if (root.getAttribute('data-vip-fit')) return;
    var url = productJsonUrl();
    if (!url || !window.fetch) return;
    if (!document.querySelector('.product-form__single-selector')) return;
    root.setAttribute('data-vip-fit', '1');
    var wrap = document.querySelector('.sc-wrap');
    var img = wrap ? wrap.querySelector('img') : null;
    var chartUrl = img ? (img.getAttribute('src') || img.getAttribute('data-src') || '') : '';

    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (product) {
      var opt = findSizeOption(product);
      if (!opt) return;
      var key = resolveTable(product.type, product.title, chartUrl, product.tags);
      if (!key) return;
      if (!wrap && !NO_CHART_OK[key]) return;
      var table = TABLES[key].sizes, rows = [];
      for (var i = 0; i < table.length; i++) {
        for (var j = 0; j < opt.values.length; j++) {
          if (String(opt.values[j]).trim().toUpperCase() === table[i][0]) { rows.push(table[i].slice()); rows[rows.length - 1][0] = opt.values[j]; break; }
        }
      }
      if (rows.length < 2) return;
      build(product, opt, key, rows, wrap);
    }).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
})();